import React from 'react';
import {upgrades} from '../../actions/upgradesArray';

export class Selectupgrade extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      selected: false,
      basePrice: 0,
      selectedPrice: 0,
      subsidy: 0,
      maxSubsidy: 0,
      taxes: 0,
      inner: "",
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleSubsidyChange = this.handleSubsidyChange.bind(this);
    this.handlePurchase = this.handlePurchase.bind(this);
  }

  createAlert = (msg) => {
    this.props.createAlert(msg);
  }

  componentWillMount() {
    let upgrade = upgrades.find((current) => {return current.id === this.props.toBuy}).purchased.includes(this.props.self.name);
    if(!upgrade){
      this.handleSelect(this.props.toBuy);
    }
  }

  componentDidMount(){
    let upgrade = upgrades.find((current) => {return current.id === this.props.toBuy}).purchased.includes(this.props.self.name);
    if(!upgrade){
      this.setInner("form");
      this.getSubsidyForm();
    } else {
      this.setInner("return");
    }
  }

  handlePurchase(e){
    e.preventDefault();
    if(this.state.selected !== false) {
      const dataForCallback = {
        name: this.state.selected,
        marketPrice: this.state.selectedPrice,
        subsidy: (this.state.subsidy === false ? 0 : this.state.subsidy),
        type: "upgrade",
      };
      this.props.callbackPurchase(dataForCallback);
    }
  }

  handleSelect(index) {
    if( !isNaN(parseInt(index, 10)) ){
      const subsidyVal = this.props.self.getApplicableSubsidies(index, "upgrades");
      let upgrade = this.props.upgrades.filter((current) => { return current.id === index })[0];

      let subsidyPlaceholder = false;
      if(subsidyVal > 0){
        if (subsidyVal > 100) {
          subsidyPlaceholder = 100;
        } else {
          subsidyPlaceholder = subsidyVal;
        }
      }

      this.setState({
        selected: upgrade.name,
        basePrice: upgrade.basePrice,
        selectedPrice: upgrade.basePrice,
        effects: upgrade.mwuBonus,
        taxes: this.props.self.getApplicableTaxes(index, "upgrades"),
        maxSubsidy: ( subsidyVal > 0 ? subsidyVal : false ),
        subsidy: subsidyPlaceholder
      });
    } else {
      this.setState({
        selected: false,
        basePrice: 0,
        selectedPrice: 0
      });
    }
  }

  handlePriceChange(net) {
    const newPrice = net;

    if ( newPrice < 0 ){
      this.createAlert("De prijs is te laag, deze moet minimaal 0 zijn");
    } else {
      this.setState({
        selectedPrice: newPrice
      });
    }
  }

  handleSubsidyChange(net) {
    const newSubsidy = net;
    if(newSubsidy > this.state.maxSubsidy) {
      this.createAlert("De overheid heeft maar \u20AC" + this.state.maxSubsidy + " te besteden in deze categorie.");
    } else {
      if ( newSubsidy < 0 ) {
        this.createAlert("Een subsidie mag niet lager zijn dan \u20AC0");
      } else if((this.state.selectedPrice - newSubsidy) < 0){
        this.createAlert("De kostprijs mag niet lager zijn dan \u20AC0");
      } else {
        this.setState({
          subsidy: parseInt(net, 10)
        });
      }
    }

  }

  loadOptions = () => {
    let selects = [];

    selects.push(<option key="_-1" defaultValue>Selecteer een upgrade om te kopen</option>);

    for (let i = 0; i < this.props.upgrades.length; i++) {
      selects.push(
        <option
          key={"_"+i}
          value={i}>
            {this.props.upgrades[i].name} {(typeof(this.props.upgrades[i].mwuBonus) === "number" ? " | " + this.props.upgrades[i].mwuBonus + "mwu" : null )}
        </option>
      );
    }
    return selects;
  };

  getSubsidyForm = () => {
    if(this.state.subsidy !== false){
      return(<div className="invisiWrap">
          <label>Subsidie</label>
          <div className="formInputNum">
            <input type='text' value={this.state.subsidy}/>
            <div onClick={() => this.changeVal("subsidy", -50)} className="formModifier formModifier--desc"></div>
            <div onClick={() => this.changeVal("subsidy", 50)} className="formModifier formModifier--asc"></div>
          </div>
        </div>);
    }
  }

  changeVal = (field, amount) => {
    if (field === "price") {
      const newVal = this.state.selectedPrice + amount
      this.handlePriceChange(newVal);
    } else if(field === "subsidy") {
      const newVal = this.state.subsidy + amount;
      this.handleSubsidyChange(newVal);
    }
    this.setInner("form");
  }

  getMwuNecessityRow = (decrease) => {
    if(this.props.stats.mwuNecessity !== undefined){
      let number = this.props.stats.mwuNecessity;
      if(decrease !== 0){
        number = parseInt(this.props.stats.mwuNecessity.toFixed(0), 10) + decrease;
      }
      return (
        <tr>
          <td>Elektriciteitsbehoefte</td>
          <td className="value">{number}</td>
          <td>MWU</td>
        </tr>
      )
    }
  }

  setInner = (set) => {
    let element;
    if(set === "return"){
      element = (
        <div>
          <h2>Deze upgrade is al gekocht.</h2>
        </div>
      )
    } else if(set === "form"){
      element = (
        <div>
          <div className="row">
            <div className="col col--data col--data-small">
              <table className="purchaseComparison">
                <thead>
                  <tr><td colSpan="3">Oude situatie</td></tr>
                </thead>
                <tbody>
                  {this.getMwuNecessityRow(0)}
                  <tr>
                    <td>Elektriciteitsvoorziening</td>
                    <td className="value">{this.props.stats.mwu.toFixed(0)}</td>
                    <td>MWU</td>
                  </tr>
                  <tr>
                    <td>Duurzaam</td>
                    <td className="value">{this.props.stats.mwuGreen.toFixed(0)}</td>
                    <td>%</td>
                  </tr>
                  <tr>
                    <td>Fossiel</td>
                    <td className="value">{100 - this.props.stats.mwuGreen.toFixed(0)}</td>
                    <td>%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col col--data col--data-small">
              <table className="purchaseComparison">
                <thead>
                  <tr><td colSpan="3">Nieuwe situatie</td></tr>
                </thead>
                <tbody>
                  {this.getMwuNecessityRow(this.state.effects)}
                  <tr>
                    <td>Elektriciteitsvoorziening</td>
                    <td className="value">{this.props.stats.mwu.toFixed(0)}</td>
                    <td>MWU</td>
                  </tr>
                  <tr>
                    <td>Duurzaam</td>
                    <td className="value">{this.props.stats.mwuGreen.toFixed(0)}</td>
                    <td>%</td>
                  </tr>
                  <tr>
                    <td>Fossiel</td>
                    <td className="value">{100 - this.props.stats.mwuGreen.toFixed(0)}</td>
                    <td>%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <form>
              <div className="formRow">
                <label>Koop {this.state.selected} van</label>
                <input type='text' value="De markt" readOnly="true"/>
              </div>
              <div className="formRow">
                <label>Type upgrade</label>
                <input type='text' value={this.state.selected} readOnly="true"/>
              </div>
              <div className="formRow">
                <label>Prijs (&euro;)</label>
                <div className="formInputNum">
                  <input type='text' readOnly="true" value={this.state.selectedPrice}/>
                  <div onClick={() => this.changeVal("price", -10)} className="formModifier formModifier--desc"></div>
                  <div onClick={() => this.changeVal("price", 10)} className="formModifier formModifier--asc"></div>
                </div>
                { this.getSubsidyForm() }
              </div>
              <div className="formRow">
                <label>Kosten (&euro;)</label>
                <div className="formInputDouble">
                  <input type='text' value={this.state.selectedPrice - this.state.subsidy + this.state.taxes} readOnly="true"/>
                </div>
                <label>Budget (&euro;)</label>
                <div className="formInputDouble">
                  <input type='text' value={Math.floor(this.props.self.funds)} readOnly="true"/>
                </div>
              </div>
              <div className="dealButton" onClick={this.handlePurchase}>
                <img alt="dealButton" src={require("../../assets/elements/Icon - deal.svg")}/>
                <div className="text">Sluit deal!</div>
              </div>
            </form>
          </div>
        </div>
      )
    }

    this.setState({
      inner: element,
    })
  }

  render(){
    return this.state.inner;
  }
}

  // NOTE: old render...
  // <form>
  //   <label>{this.props.toBuy}</label>
  //   <select onChange={this.handleSelect}>
  //     {this.loadOptions()}
  //   </select>
  //   <label>
  //     Subsidies:
  //     <input type="number" step="1" onChange={this.handleSubsidyChange} value={this.state.subsidy}/>
  //   </label>
  //   <label>
  //     Belasting:
  //     <p>{this.state.taxes}</p>
  //   </label>
  //   <label>
  //     Marktprijs:
  //     <input type="number" step="10" onChange={this.handlePriceChange} value={this.state.selectedPrice}/>
  //   </label>
  //
  //   <label>
  //     Totaalprijs:
  //     <p>{this.state.selectedPrice - this.state.subsidy + this.state.taxes}</p>
  //   </label>
  //   <button onClick={this.handlePurchase}>Koop!</button>
  // </form>



// WEBPACK FOOTER //
// ./src/components/interactive/selectUpgrade.js